import { API } from "../urls";

// Cookie tabanlı auth: credentials:'include' ile access_token cookie otomatik gönderilir.
const fetchOpts = { credentials: "include" };
const jsonHeaders = { "Content-Type": "application/json" };

/**
 * Resmî tatil takvimi. Valör (T+X iş günü) hesabında hafta sonlarıyla birlikte
 * bu günler atlanır; eksik takvim yatış tarihini erkene çeker ve tutarı yanlış
 * aya yazar. Tüm uçlar SUPER_ADMIN'e kapalıdır.
 */

/**
 * Bir yılın takvimi. Yanıt iki tür günü birlikte içerir:
 * - fixed=true  → koddan üretilen sabit tarihli millî bayram (düzenlenemez)
 * - fixed=false → elle girilen gün (dini bayram, köprü günü, idari tatil)
 * @param {number} [year]
 */
export const fetchPublicHolidays = async (year) => {
    const res = await fetch(API.public_holidays(year), fetchOpts);
    return res.json();
};

/**
 * Tek gün ekler veya açıklamasını günceller. Sabit tarihli millî bayramlar
 * reddedilir (400) — onlar zaten otomatik takvimde.
 * @param {{holidayDate: string, description: string}} holiday
 */
export const savePublicHoliday = async (holiday) => {
    const res = await fetch(API.public_holidays(), {
        ...fetchOpts,
        method: "PUT",
        headers: jsonHeaders,
        body: JSON.stringify(holiday),
    });
    return res.json();
};

/** Elle girilmiş bir günü siler. @param {string} date YYYY-MM-DD */
export const deletePublicHoliday = async (date) => {
    const res = await fetch(API.public_holiday_delete(date), {
        ...fetchOpts,
        method: "DELETE",
    });
    return res.json();
};

/**
 * Bir yılın takvimini tek istekte girer. Liste önce bütün olarak doğrulanır;
 * tek bir hatalı gün varsa hiçbiri yazılmaz.
 * @param {{year:number, holidays:Array, replaceYear?:boolean, confirmYear?:boolean}} request
 */
export const bulkSavePublicHolidays = async (request) => {
    const res = await fetch(API.public_holidays_bulk(), {
        ...fetchOpts,
        method: "PUT",
        headers: jsonHeaders,
        body: JSON.stringify(request),
    });
    return res.json();
};

/** Yıl bazında durum: kaç gün girilmiş, onaylanmış mı, kim onaylamış. */
export const fetchHolidayYears = async () => {
    const res = await fetch(API.public_holiday_years(), fetchOpts);
    return res.json();
};

/**
 * "Bu yılın takvimi tamamdır" işareti. Onaylanmayan yıla düşen valör hesabı
 * POS raporlarında uyarı döndürür.
 */
export const confirmHolidayYear = async (year) => {
    const res = await fetch(API.public_holiday_year_confirm(year), {
        ...fetchOpts,
        method: "PUT",
    });
    return res.json();
};

/** Onayı geri alır (yıl içinde yeni bir köprü günü ilan edilirse). */
export const unconfirmHolidayYear = async (year) => {
    const res = await fetch(API.public_holiday_year_confirm(year), {
        ...fetchOpts,
        method: "DELETE",
    });
    return res.json();
};
